var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.404,
    height: 12.404,
    viewBox: "0 0 12.404 12.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_39",
    "data-name": "Groupe 39",
    transform: "translate(282.785 -648.948) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_34",
    "data-name": "Trac\\xE9 34",
    d: "M5.14,0,0,5.14l5.14,5.14",
    transform: "translate(272.827 656.477) rotate(90)",
    fill: "none",
    stroke: "#3c3c3b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_65",
    "data-name": "Trac\\xE9 65",
    d: "M682.592,656.477v8.612",
    transform: "translate(-414.905)",
    fill: "none",
    stroke: "#3c3c3b",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.2cd30f32e232c7c52c814c76876cb236.svg";
export { ForwardRef as ReactComponent };